<template>
	<div>
		<van-tabbar v-model="active" :placeholder="true">
			<van-tabbar-item icon="shop-o" name="/ShopIndex" to="/ShopIndex">商城</van-tabbar-item>
			<van-tabbar-item icon="shopping-cart-o" name="/ShopCar" to="/ShopCar" :badge="goodsCount">
				购物车
			</van-tabbar-item>
			<!-- <van-tabbar-item icon="newspaper-o" name="/News" to="/News">公告</van-tabbar-item> -->
			<van-tabbar-item icon="paid" name="/Wallet" to="/Wallet">钱包</van-tabbar-item>
			<van-tabbar-item icon="user-o" name="/User" to="/User">我的</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Tabbar,
		TabbarItem
	} from "vant";

	Vue.use(Tabbar);
	Vue.use(TabbarItem);

	export default {
		data() {
			return {
				active: "",
				goodsCount: ""
			};
		},
		created() {
			this.getcarcount();
			this.active = this.$route.path;
		},
		mounted() {},
		methods: {
			getcarcount: function() {
				if (
					JSON.parse(localStorage.getItem("goodslist")) != null &&
					JSON.parse(localStorage.getItem("goodslist")).length > 0
				) {
					this.goodsCount = JSON.parse(localStorage.getItem("goodslist")).length;
				}
			}
		}
	};
</script>

<style>
	.van-tabbar-item--active{
		font-weight: 600;
		color: #574AA5;
	}
	
</style>
